module.exports = __webpack_public_path__ + "media/images/sp/stores/common/flow_2-db8100a850ce0c88e5ee1b9884f76e4e.jpg";